module.exports = __webpack_public_path__ + "img/SES_500421000.c3922c93.jpg";